import React, { Component } from 'react';
import AuthorizationCodeGrantComponent from '../service/AuthorizationCodeGrantComponent';
import ProgressRing from '@hig/progress-ring';
import {
  URL_LOGOUT_STG,
  URL_USER_PROFILE_STG,
  LOCALHOST_DEPLOY_CLIENT_ID,
  LOCALHOST_DEPLOY_CALLBACK_URL,
} from '../service/constants';

export const withAuthentication = (Wrapped) => {
  class WithAuthentication extends Component {
    constructor(props) {
      super(props);
      this.hiddenIframe = null;
      // This is the forge app for localhost testing
      const callbackUrl = window.location.origin + window.location.pathname;

      this.authenticationConfig = {
        clientId: LOCALHOST_DEPLOY_CLIENT_ID,
        callbackUrl: callbackUrl || LOCALHOST_DEPLOY_CALLBACK_URL,
      };

      // Define configuration information used to authenticate our app.
      if (window['client-data']) {
        this.authenticationConfig.clientId = window['client-data'].id;
      }

      this.state = {
        token: null,
        userName: '',
        userId: '',
        userImage: '',
      };
    }

    componentDidMount() {
      const auth = new AuthorizationCodeGrantComponent(this.authenticationConfig);
      auth
        .getBearerToken()
        .then((token) => {
          // get user profile.
          fetch(URL_USER_PROFILE_STG, {
            method: 'GET',
            headers: {
              authorization: `Bearer ${token}`,
            },
          })
            .then((response) => {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error('Failed to get user profile');
              }
            })
            .then((userInfo) => {
              const { firstName, lastName, userId, emailId, profileImages } = userInfo;

              this.setState({
                token,
                userName: `${firstName} ${lastName}`,
                userId,
                userEmail: emailId,
                userImage: profileImages.sizeX360,
              });
            })
            .catch((error) => {
              console.warn('failed to get user profile - ' + error.message);
            });
        })
        .catch((error) => {
          console.warn('failed to get token - ' + error.message);
        });
    }

    logout = () => {
      if (this.hiddenIframe) {
        // Subscribe to the load event to see
        // when the LogOut page got loaded
        const self = this;
        this.hiddenIframe.onload = function () {
          // Unsubscribe from event
          self.hiddenIframe.onload = null;
          window.location.replace(window.location.origin);
        };

        // Load the LogOut page
        this.hiddenIframe.src = URL_LOGOUT_STG;
      }
    };

    render() {
      const { token, userId, userName, userEmail, userImage } = this.state;
      if (!token) {
        return <ProgressRing size="l" />;
      }
      return (
        <>
          <Wrapped
            className="auth"
            token={token}
            userId={userId}
            userName={userName}
            userEmail={userEmail}
            userImage={userImage}
            _handleLogout={this.logout}
            {...this.props}
          />
          <iframe
            ref={(n) => {
              this.hiddenIframe = n;
            }}
            style={{ visibility: 'hidden', height: 0 }}
          />
        </>
      );
    }
  }
  return WithAuthentication;
};

export default withAuthentication;
